import { Box, Container } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/Button";
import PasswordInput from "../../components/ui/PasswordInput";
import Text from "../../components/ui/Text";

const SettingsPassword = ({ isDesktop = false }) => {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const handleBack = () => {
    navigate("/settings");
  };

  const handleSave = () => {
    // TODO: Implement password change logic
    // Navigate back or show success message
  };

  const handleForgotPassword = () => {
    // TODO: Implement forgot password logic
    navigate("/forgot-password");
  };

  const isSaveDisabled =
    !currentPassword ||
    !newPassword ||
    !confirmNewPassword ||
    newPassword !== confirmNewPassword;

  // Desktop layout (no container, no back button)
  if (isDesktop) {
    return (
      <Box>
        {/* Password Fields */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            mb: "40px",
          }}
        >
          <PasswordInput
            label="Current password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />

          <PasswordInput
            label="New password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />

          <PasswordInput
            label="Confirm new password"
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
          />
        </Box>

        {/* Forgot Password Link */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
          <Text
            variant="paragraph3"
            sx={{
              color: "#1890FF",
              cursor: "pointer",
              textDecoration: "underline",
              fontSize: "14px",
            }}
            onClick={handleForgotPassword}
          >
            Forgot password?
          </Text>
        </Box>

        {/* Save Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={isSaveDisabled}
            sx={{ minWidth: "120px", width: "auto" }}
          >
            Save
          </Button>
        </Box>
      </Box>
    );
  }

  // Mobile layout (original)
  return (
    <Container maxWidth="sm" sx={{ mt: 2 }}>
      {/* Back Button */}
      <Box sx={{ mb: "24px" }}>
        <Button variant="back" onClick={handleBack} />
      </Box>

      {/* Page Header */}
      <Text variant="pageHeader" sx={{ mb: "40px" }}>
        Change password
      </Text>

      {/* Password Fields */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          mb: "40px",
        }}
      >
        <PasswordInput
          label="Current password"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />

        <PasswordInput
          label="New password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <PasswordInput
          label="Confirm new password"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
        />
      </Box>

      {/* Forgot Password Link */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 3 }}>
        <Text
          variant="paragraph3"
          sx={{
            color: "#1890FF",
            cursor: "pointer",
            textDecoration: "underline",
            fontSize: "14px",
          }}
          onClick={handleForgotPassword}
        >
          Forgot password?
        </Text>
      </Box>

      {/* Save Button */}
      <Button
        variant="primary"
        onClick={handleSave}
        disabled={isSaveDisabled}
        sx={{ width: "100%" }}
      >
        Save
      </Button>
    </Container>
  );
};

export default SettingsPassword;
